import { render, staticRenderFns } from "./AddEditCategorie.vue?vue&type=template&id=59bdfc9c&"
import script from "./AddEditCategorie.vue?vue&type=script&lang=js&"
export * from "./AddEditCategorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports